const style = {
  container: {
    sx: {
      alignItems: 'center',
      display: 'flex',
      flexWrap: 'wrap',
      gap: 2,
      p: 2,
    },
  },
  select: {
    sx: {
      minWidth: 180,
    },
  },
  actions: {
    sx: {
      marginLeft: 'auto',
    },
  },
} as const;

export default style;
